var render, staticRenderFns
import script from "./DraggableItem3.vue?vue&type=script&lang=js"
export * from "./DraggableItem3.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem3.vue?vue&type=style&index=0&id=22a58445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a58445",
  null
  
)

export default component.exports